import { UpdateJobRequest } from 'utils/atsUtils'
import { Job } from '../jobs/actions'

export type StoreJob = {
  data: {
    job: {
      storedJob: Partial<Job>
      updatedJob: Partial<Job>
      changedValues?: UpdateJobRequest
    }
  }
}

export const STORE_JOB = 'STORE_JOB'
